<template>
  <div class="page-container" v-loading="reviewing" element-loading-text="正在审批当中" element-loading-background="rgba(255,255,255,0.7)">
    <!-- 统计卡片区 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">出金成功人数</span>
          <span class="stat-icon blue">👥</span>
        </div>
        <div class="stat-value">{{ stats.userCount }}</div>
        <div class="stat-change"><span class="change-text">出金成功订单去重用户</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">出金笔数</span>
          <span class="stat-icon green">📊</span>
        </div>
        <div class="stat-value">{{ stats.orderCount }}</div>
        <div class="stat-change"><span class="change-text">出金成功订单笔数</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">出金金额(USD)</span>
          <span class="stat-icon purple">💰</span>
        </div>
        <div class="stat-value">{{ fmtAmount(stats.totalAmount) }}</div>
        <div class="stat-change"><span class="change-text">最终出金金额合计</span></div>
      </div>
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-label">手续费(USD)</span>
          <span class="stat-icon amber">🏦</span>
        </div>
        <div class="stat-value">{{ fmtAmount(stats.totalFee) }}</div>
        <div class="stat-change"><span class="change-text">成功订单手续费合计</span></div>
      </div>
    </div>

    <!-- 筛选查询区 -->
    <div class="table-wrapper">
      <el-form :inline="true" size="small" class="filter-form" @submit.native.prevent>
        <el-form-item label="用户ID">
          <el-input v-model="search.userId" placeholder="多个用逗号分隔" clearable style="width:160px;"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="search.customerName" placeholder="请输入姓名" clearable style="width:120px;"></el-input>
        </el-form-item>
        <el-form-item label="国家">
          <el-input v-model="search.countryCode" placeholder="国家/地区代码" clearable style="width:120px;"></el-input>
        </el-form-item>
        <el-form-item label="客户组别">
          <el-select v-model="search.customerGroupId" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出金账号类型">
          <el-select v-model="search.accountType" placeholder="全部" clearable style="width:110px;">
            <el-option label="真实" :value="2"></el-option>
            <el-option label="钱包" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出金账号">
          <el-input v-model="search.accountNo" placeholder="MT5 Login" clearable style="width:120px;"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="search.orderNo" placeholder="订单号" clearable style="width:140px;"></el-input>
        </el-form-item>
        <el-form-item label="出金币种">
          <el-select v-model="search.currency" placeholder="全部" clearable style="width:140px;">
            <el-option v-for="c in currencies" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="search.status" placeholder="全部" clearable style="width:110px;">
            <el-option v-for="s in orderStatusOptions" :key="s.key" :label="s.label" :value="s.key"></el-option>
          </el-select>
        </el-form-item>

        <template v-if="filterExpanded">
          <el-form-item label="支付平台">
            <el-select v-model="search.payPlatform" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="p in platformOptions" :key="p.code" :label="p.desc" :value="p.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出金方式">
            <el-select v-model="search.payMethod" placeholder="全部" clearable style="width:120px;">
              <el-option v-for="m in payMethods" :key="m" :label="m" :value="m"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="代付商户号">
            <el-input v-model="search.merchantNo" placeholder="代付商户号" clearable style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="三方订单号">
            <el-input v-model="search.channelOrderNo" placeholder="三方订单号" clearable style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="账户币种">
            <el-select v-model="search.accountCurrency" placeholder="全部" clearable style="width:110px;">
              <el-option v-for="c in accountCurrencies" :key="c" :label="c" :value="c"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单来源">
            <el-select v-model="search.source" placeholder="全部" clearable style="width:110px;">
              <el-option v-for="s in sources" :key="s" :label="s" :value="s"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="search.reviewStatus" placeholder="全部" clearable style="width:110px;">
              <el-option label="待审核" :value="1"></el-option>
              <el-option label="已通过" :value="2"></el-option>
              <el-option label="已拒绝" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker v-model="orderDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" style="width:250px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="审核时间">
            <el-date-picker v-model="reviewDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" style="width:250px;"></el-date-picker>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchList">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          <el-button type="text" @click="toggleFilter">{{ filterExpanded ? '收起 ▴' : '展开 ▾' }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 审核状态 Tab -->
    <div class="tabs-wrap">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane v-for="t in reviewStatusTabs" :key="t.key" :name="t.key">
          <span slot="label">{{ t.label }} <span class="tab-count">{{ tabCount(t) }}</span></span>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 订单列表 -->
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">出金订单列表</span>
        <div class="table-actions">
          <button v-auth="'payment:withdrawalManager:review'" class="btn btn-approve btn-sm" @click="handleBatchReview(2)">✓ 审核</button>
          <button v-auth="'payment:withdrawalManager:review'" class="btn btn-reject btn-sm" @click="handleBatchReview(3)">✕ 拒绝</button>
          <button class="btn btn-secondary btn-sm" @click="refreshList">🔄 刷新</button>
          <button v-auth="'payment:withdrawalManager:export'" class="btn btn-secondary btn-sm" @click="handleExport">📥 导出</button>
        </div>
      </div>
      <el-table :data="tableData" border v-loading="loading" @selection-change="handleSelectionChange" style="width:100%;">
        <el-table-column type="selection" width="42" fixed="left" align="center"></el-table-column>
        <el-table-column label="订单号" width="180" fixed="left">
          <template slot-scope="{row}"><span class="order-no">{{ row.orderNo || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100">
          <template slot-scope="{row}"><span class="mono">{{ row.customerNo || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="customerName" label="姓名" width="90">
          <template slot-scope="{row}">{{ row.customerName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="countryName" label="国家" width="90">
          <template slot-scope="{row}">{{ row.countryName || row.countryCode || '--' }}</template>
        </el-table-column>
        <el-table-column prop="customerGroup" label="客户组别" width="120">
          <template slot-scope="{row}">{{ row.customerGroup || '--' }}</template>
        </el-table-column>
        <el-table-column label="出金账号类型" width="105">
          <template slot-scope="{row}">{{ row.accountTypeName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="accountNo" label="出金账号" width="110">
          <template slot-scope="{row}"><span class="mono">{{ row.accountNo || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="payPlatformName" label="支付平台" width="100">
          <template slot-scope="{row}">{{ row.payPlatformName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="payMethod" label="支付方式" width="95">
          <template slot-scope="{row}"><span class="badge">{{ row.payMethod || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="merchantNo" label="代付商户号" width="130">
          <template slot-scope="{row}"><span class="mono">{{ row.merchantNo || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="channelOrderNo" label="三方订单号" width="150">
          <template slot-scope="{row}"><span class="mono">{{ row.channelOrderNo || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="payAccount" label="收款账户" width="120">
          <template slot-scope="{row}">{{ row.payAccount || '--' }}</template>
        </el-table-column>
        <el-table-column label="出金金额" width="120" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.amount) }}</span></template>
        </el-table-column>
        <el-table-column prop="currency" label="出金币种" width="115"></el-table-column>
        <el-table-column label="实际出金金额" width="120" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.actualAmount) }}</span></template>
        </el-table-column>
        <el-table-column label="通道实付金额" width="120" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.channelPayAmount) }}</span></template>
        </el-table-column>
        <el-table-column prop="settleCurrency" label="结算币种" width="95">
          <template slot-scope="{row}">{{ row.settleCurrency || '--' }}</template>
        </el-table-column>
        <el-table-column label="最终出金金额" width="120" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.finalAmount) }}</span></template>
        </el-table-column>
        <el-table-column prop="accountCurrency" label="账户币种" width="90">
          <template slot-scope="{row}">{{ row.accountCurrency || '--' }}</template>
        </el-table-column>
        <el-table-column label="手续费" width="110" align="right">
          <template slot-scope="{row}"><span class="mono">{{ fmtAmount(row.fee) }}</span></template>
        </el-table-column>
        <el-table-column label="汇率" width="100" align="right">
          <template slot-scope="{row}"><span class="mono">{{ row.rate != null ? row.rate : '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="source" label="订单来源" width="100">
          <template slot-scope="{row}">{{ row.source || '--' }}</template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="statusTagType(row.status)" size="small">{{ row.statusName || '--' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="reviewTagType(row.reviewStatus)" size="small">{{ row.reviewStatusName || '--' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
        </el-table-column>
        <el-table-column label="审核时间" width="160">
          <template slot-scope="{row}">{{ fmtDateTime(row.reviewTime) }}</template>
        </el-table-column>
        <el-table-column prop="reviewUser" label="审核人" width="100">
          <template slot-scope="{row}">{{ row.reviewUser || '--' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="140">
          <template slot-scope="{row}">
            <span v-if="row.remark" class="remark" :title="row.remark">{{ row.remark }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button v-auth="'payment:withdrawalManager:find'" type="text" size="small" style="color:var(--brand-primary);" @click="openDetail(row)">详情</el-button>
            <template v-if="row.reviewStatus === 1">
              <el-button v-auth="'payment:withdrawalManager:review'" type="text" size="small" style="color:var(--brand-primary);" @click="handleRowReview(row, 2)">审核</el-button>
              <el-button v-auth="'payment:withdrawalManager:review'" type="text" size="small" style="color:#F56C6C;" @click="handleRowReview(row, 3)">拒绝</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="720px" :close-on-click-modal="false" title="出金订单详情">
      <div v-if="detail" class="detail-body">
        <div class="detail-section">
          <div class="detail-title">订单信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">订单号：</span><span class="detail-strong">{{ detail.orderNo || '--' }}</span></div>
            <div><span class="detail-label">三方订单号：</span>{{ detail.channelOrderNo || '--' }}</div>
            <div><span class="detail-label">订单状态：</span><el-tag :type="statusTagType(detail.status)" size="small">{{ detail.statusName || '--' }}</el-tag></div>
            <div><span class="detail-label">审核状态：</span><el-tag :type="reviewTagType(detail.reviewStatus)" size="small">{{ detail.reviewStatusName || '--' }}</el-tag></div>
            <div><span class="detail-label">申请时间：</span>{{ fmtDateTime(detail.createDate) }}</div>
            <div><span class="detail-label">审核时间：</span>{{ fmtDateTime(detail.reviewTime) }}</div>
            <div><span class="detail-label">审核人：</span>{{ detail.reviewUser || '--' }}</div>
            <div><span class="detail-label">订单来源：</span>{{ detail.source || '--' }}</div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">用户信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">用户ID：</span><span class="mono">{{ detail.customerNo || '--' }}</span></div>
            <div><span class="detail-label">姓名：</span>{{ detail.customerName || '--' }}</div>
            <div><span class="detail-label">国家：</span>{{ detail.countryName || detail.countryCode || '--' }}</div>
            <div><span class="detail-label">客户组别：</span>{{ detail.customerGroup || '--' }}</div>
            <div><span class="detail-label">出金账号类型：</span>{{ detail.accountTypeName || '--' }}</div>
            <div><span class="detail-label">出金账号：</span><span class="mono">{{ detail.accountNo || '--' }}</span></div>
          </div>
        </div>
        <div class="detail-section">
          <div class="detail-title">支付信息</div>
          <div class="detail-grid">
            <div><span class="detail-label">支付平台：</span>{{ detail.payPlatformName || '--' }}</div>
            <div><span class="detail-label">支付方式：</span>{{ detail.payMethod || '--' }}</div>
            <div><span class="detail-label">代付商户号：</span><span class="mono">{{ detail.merchantNo || '--' }}</span></div>
            <div><span class="detail-label">收款账户：</span>{{ detail.payAccount || '--' }}</div>
            <div><span class="detail-label">出金币种：</span>{{ detail.currency || '--' }}</div>
            <div><span class="detail-label">出金金额：</span><span class="mono">{{ fmtAmount(detail.amount) }}</span></div>
            <div><span class="detail-label">实际出金金额：</span><span class="mono">{{ fmtAmount(detail.actualAmount) }}</span></div>
            <div><span class="detail-label">通道实付金额：</span><span class="mono">{{ fmtAmount(detail.channelPayAmount) }}</span></div>
            <div><span class="detail-label">支付平台结算币种：</span>{{ detail.settleCurrency || '--' }}</div>
            <div><span class="detail-label">最终出金金额：</span><span class="mono">{{ fmtAmount(detail.finalAmount) }}</span></div>
            <div><span class="detail-label">账户币种：</span>{{ detail.accountCurrency || '--' }}</div>
            <div><span class="detail-label">手续费：</span><span class="mono">{{ fmtAmount(detail.fee) }}</span></div>
            <div><span class="detail-label">汇率：</span><span class="mono">{{ detail.rate != null ? detail.rate : '--' }}</span></div>
          </div>
          <div v-if="detail.remark" class="remark-box"><span class="detail-label">备注：</span>{{ detail.remark }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { withdrawalManagerList, withdrawalManagerStats, withdrawalManagerReviewStatusCounts, withdrawalManagerBatchReview, withdrawalManagerExport } from '@/api/withdrawalManager'
import { customerGroupList } from '@/api/customerGroup'

export default {
  name: 'WithdrawManagerList',
  data() {
    return {
      stats: { userCount: 0, orderCount: 0, totalAmount: 0, totalFee: 0 },
      statusCounts: {},
      search: {
        userId: '', customerName: '', countryCode: '', customerGroupId: null,
        accountType: null, accountNo: '', orderNo: '',
        currency: '', status: null,
        payPlatform: null, payMethod: '', merchantNo: '',
        channelOrderNo: '', accountCurrency: '', source: '', reviewStatus: null
      },
      filterExpanded: false,
      activeTab: 'all',
      reviewStatusTabs: [
        { key: 'all', label: '全部' },
        { key: '1', label: '待审核' },
        { key: '2', label: '已通过' },
        { key: '3', label: '已拒绝' }
      ],
      orderStatusOptions: [
        { key: 1, label: '待处理' },
        { key: 2, label: '处理中' },
        { key: 3, label: '出金成功' },
        { key: 4, label: '出金失败' }
      ],
      platformOptions: [
        { code: 2, desc: 'MaxPay' },
        { code: 3, desc: '银联商务' },
        { code: 4, desc: 'Exlink' }
      ],
      payMethods: ['USDT', 'USDT-Polygon', 'USDT-ERC20', 'USDT-BEP20', 'USDT-TRC20', 'Bank', 'AliPay', 'WeChat'],
      currencies: ['CNY', 'USDT-TRC20', 'USDT-ERC20', 'USD'],
      accountCurrencies: ['USD', 'CNY'],
      sources: ['Android', 'IOS', 'H5', 'PC'],
      groupOptions: [],
      orderDateRange: null,
      reviewDateRange: null,
      tableData: [], loading: false, reviewing: false, total: 0,
      pageNum: 1, pageSize: 15,
      selection: [],
      detailVisible: false, detail: null
    }
  },
  created() { this.fetchGroups(); this.fetchStats(); this.fetchStatusCounts(); this.fetchList() },
  methods: {
    buildParams(extra = {}) {
      const data = Object.assign({}, this.search, extra)
      if (this.orderDateRange && this.orderDateRange.length === 2) {
        data.createDateStart = this.orderDateRange[0]
        data.createDateEnd = this.orderDateRange[1]
      }
      if (this.reviewDateRange && this.reviewDateRange.length === 2) {
        data.reviewDateStart = this.reviewDateRange[0]
        data.reviewDateEnd = this.reviewDateRange[1]
      }
      return data
    },
    fetchGroups() {
      customerGroupList({ pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) this.groupOptions = res.result.list || []
      })
    },
    fetchStats() {
      withdrawalManagerStats(this.buildParams()).then(res => {
        if (res.code === 0) this.stats = res.result || this.stats
      })
    },
    fetchStatusCounts() {
      withdrawalManagerReviewStatusCounts(this.buildParams()).then(res => {
        if (res.code === 0) this.statusCounts = res.result || {}
      })
    },
    tabCount(t) {
      const c = this.statusCounts || {}
      return t.key === 'all' ? (c.total || 0) : (c[t.key] || 0)
    },
    fetchList() {
      this.loading = true
      withdrawalManagerList(this.buildParams({ pageNum: this.pageNum, pageSize: this.pageSize })).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.loading = false })
    },
    searchList() { this.pageNum = 1; this.fetchList(); this.fetchStats(); this.fetchStatusCounts() },
    resetSearch() {
      this.search = {
        userId: '', customerName: '', countryCode: '', customerGroupId: null,
        accountType: null, accountNo: '', orderNo: '',
        currency: '', status: null,
        payPlatform: null, payMethod: '', merchantNo: '',
        channelOrderNo: '', accountCurrency: '', source: '',
        reviewStatus: this.activeTab === 'all' ? null : Number(this.activeTab)
      }
      this.orderDateRange = null
      this.reviewDateRange = null
      this.pageNum = 1
      this.fetchList(); this.fetchStats(); this.fetchStatusCounts()
    },
    toggleFilter() { this.filterExpanded = !this.filterExpanded },
    handleTabClick() {
      this.search.reviewStatus = this.activeTab === 'all' ? null : Number(this.activeTab)
      this.pageNum = 1
      this.fetchList()
    },
    refreshList() {
      this.pageNum = 1
      this.fetchStats()
      this.fetchStatusCounts()
      this.fetchList()
      this.$message.success('刷新成功')
    },
    handleSelectionChange(val) { this.selection = val },
    handleBatchReview(reviewStatus) {
      if (!this.selection.length) { this.$message.warning('请先勾选要审核的订单'); return }
      const n = this.selection.length
      const tip = reviewStatus === 2
        ? `确认通过选中的 ${n} 笔出金订单？通过后将提交第三方代付`
        : `确认拒绝选中的 ${n} 笔出金订单？`
      this.$confirm(tip, '审核确认', { type: 'warning' })
        .then(() => this.submitReview(this.selection.map(r => r.id).join(','), reviewStatus))
        .catch(() => {})
    },
    handleRowReview(row, reviewStatus) {
      const tip = reviewStatus === 2
        ? `确认通过订单 ${row.orderNo}？通过后将提交第三方代付`
        : `确认拒绝订单 ${row.orderNo}？`
      this.$confirm(tip, '审核确认', { type: 'warning' })
        .then(() => this.submitReview(String(row.id), reviewStatus))
        .catch(() => {})
    },
    submitReview(ids, reviewStatus) {
      this.reviewing = true
      withdrawalManagerBatchReview(ids, reviewStatus).then(res => {
        if (res.code === 0) {
          const list = res.result || []
          if (reviewStatus === 2) {
            const fail = list.filter(v => !v.success)
            if (fail.length) {
              this.$alert(
                `共 ${list.length} 笔，失败 ${fail.length} 笔：\n` + fail.map(v => `${v.orderNo || ''}：${v.message || '提交失败'}`).join('\n'),
                '提交第三方结果', { type: 'warning' })
            } else if (list.length) {
              this.$message.success(`审核通过，${list.length} 笔订单已提交第三方`)
            } else {
              this.$message.success('审核通过')
            }
          } else {
            this.$message.success('拒绝成功')
          }
          this.selection = []
          this.fetchStats()
          this.fetchStatusCounts()
          this.fetchList()
        } else this.$message.error(res.message || '操作失败')
      }).finally(() => { this.reviewing = false })
    },
    handleExport() {
      withdrawalManagerExport(this.buildParams()).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '出金订单.xlsx'; a.click()
        URL.revokeObjectURL(url)
      })
    },
    openDetail(row) { this.detail = row; this.detailVisible = true },
    statusTagType(s) { return { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger' }[s] || 'info' },
    reviewTagType(s) { return { 1: 'warning', 2: 'success', 3: 'danger' }[s] || 'info' },
    fmtAmount(v) {
      if (v === null || v === undefined || v === '') return '--'
      const n = Number(v)
      return isNaN(n) ? '--' : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.stats-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 16px; }
.stat-card { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.stat-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.stat-label { font-size: 13px; color: #5a6578; }
.stat-icon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.stat-icon.blue { background: #eef4ff; }
.stat-icon.green { background: #ecfdf5; }
.stat-icon.purple { background: #f5f3ff; }
.stat-icon.amber { background: #fffbeb; }
.stat-value { font-size: 24px; font-weight: 700; color: #1a2236; margin-bottom: 4px; }
.stat-change { font-size: 12px; color: #9ca3af; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.tabs-wrap { background: #fff; border-radius: 10px; padding: 4px 16px 0; margin-bottom: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.tab-count { display: inline-block; min-width: 18px; padding: 0 5px; margin-left: 4px; border-radius: 8px; background: #eef2f7; color: #5a6578; font-size: 12px; line-height: 18px; text-align: center; }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 6px 12px; border-radius: 5px; font-size: 12px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-approve { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-reject { background: #fff; color: #dc2626; border-color: #dc2626; }
.btn-secondary { background: #fff; color: #5a6578; border-color: #e8ecf2; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
.badge { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; color: var(--brand-primary); background: var(--brand-primary-a12); }
.mono { font-family: 'JetBrains Mono', monospace; font-size: 12px; }
.order-no { color: var(--brand-primary); font-size: 12px; font-weight: 500; }
.remark { display: inline-block; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; }
.detail-body { padding: 0 4px; }
.detail-section { margin-bottom: 20px; }
.detail-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; font-size: 13px; }
.detail-label { color: #9ca3af; }
.detail-strong { font-weight: 500; }
.remark-box { margin-top: 12px; font-size: 13px; }
</style>
